<template lang="html">
  <div class="fixed-img" v-show="loading">
    <i class="iconfont icon-guanbi" @click="close"></i>
    <div class="fixed-img-box">
        <img :src="url" class="share-img">
        <p>长按图片保存到手机分享客户</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loading:false,
    url:"",
  },
  methods: {
      close(){
          this.$emit('update:loading', false)
      }
  }
};
</script>

<style lang="scss" scoped>
.fixed-img{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.9);
    .fixed-img-box{
        width: 10rem;
        height: 100vh;
        overflow: auto;
        padding-bottom: 30px;
        .share-img{
            width: 8rem;
            display: block;
            margin: 20px auto;
        }
        p{
            color: #fff;
            text-align: center;
            font-size: 30px;
        }
    }
    .iconfont{
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 40px;
        color: #fff;
        z-index: 22;
    }
}
</style>